const develop = {
    apiBase: 'https://rxapp.services.chailv8.net',
    // apiBase: 'http://localhost:8080',
};

const cnpc = {
    apiBase: 'https://rxapp.services.cnpc.chailv8.com',
};

const newDevelop = {
    apiBase: 'https://rxapi.kld.kdtmc.net',
};

const newCnpc = {
    apiBase: 'https://rxapi.kld.kdtmc.com',
};

function getConfig() {
    switch (window.location.hostname) {
        case 'rxweb.services.chailv8.net':
            return develop;
        case 'rxweb.services.cnpc.chailv8.com':
            return cnpc;
        case 'rxweb.kld.kdtmc.net':
            return newDevelop;
        case 'rxweb.kld.kdtmc.com':
            return newCnpc;
        default:
            return develop;
    }
}

const current = getConfig();

const getApiURL = path => current.apiBase + (path === undefined ? '/' : path);

export {
    getApiURL
};



// WEBPACK FOOTER //
// ./src/config.js